export const articlesHeroSubtitle = 'Research & Publications';
export const articlesHeroTitle = 'Publications & Research';
export const articlesHeroDescription = 'Explore SALTED\'s research achievements and academic papers';

export const articlesPageTitle = 'Research';
export const articlesLoginNotice = 'Please log in to download articles.';
export const articlesLoginButton = 'Quick Login';

// Categories
export const categoryAll = 'All';
export const categoryMotion = 'Motion Analysis';
export const categoryEMG = 'Surface EMG';
export const categoryGait = 'Gait Analysis';
export const categoryBalance = 'Balance Analysis';
export const categorySpine = 'Spine Structure';
export const categoryStrength = 'Strength/Sensation';
export const categoryTherapy = 'Heat/Electric';
export const categorySwallowing = 'Swallowing Disorder';
export const categoryCognitive = 'Cognitive Rehab';
export const categoryRespiratory = 'Respiratory Rehab';

// Search
export const searchTypeTitle = 'Title';
export const searchTypeProduct = 'Product';
export const searchPlaceholder = 'Enter search term';
export const searchButton = 'Search';
export const resetButton = 'Reset';

// Table
export const tableHeaderTitle = 'Title';
export const tableHeaderDownload = 'DOWNLOAD';
export const noResults = 'No search results found.';
export const loading = 'Loading...';

// Pagination
export const paginationFirst = 'First';
export const paginationPrev = 'Previous';
export const paginationNext = 'Next';
export const paginationLast = 'Last';

export default {
  articlesHeroSubtitle,
  articlesHeroTitle,
  articlesHeroDescription,
  articlesPageTitle,
  articlesLoginNotice,
  articlesLoginButton,
  categoryAll,
  categoryMotion,
  categoryEMG,
  categoryGait,
  categoryBalance,
  categorySpine,
  categoryStrength,
  categoryTherapy,
  categorySwallowing,
  categoryCognitive,
  categoryRespiratory,
  searchTypeTitle,
  searchTypeProduct,
  searchPlaceholder,
  searchButton,
  resetButton,
  tableHeaderTitle,
  tableHeaderDownload,
  noResults,
  loading,
  paginationFirst,
  paginationPrev,
  paginationNext,
  paginationLast
};
